/* eslint-disable no-console */
/* eslint-disable no-useless-concat */
/* eslint-disable no-underscore-dangle */
import { Wrap } from './styles';

import Layer from 'services/models/Layer';
import geoAlert from 'services/utils/alert';
import { getPropertiesChangedOldFeature, getFeaturesTurf } from 'services/utils/layerUtils';
import { measureArea } from 'services/utils/measures';

import ButtonTooltip from '../../ButtonTooltip';

import { CustomModalSaveAsLayer } from 'views/MapView/components/CustomModalSaveAsLayer';

import Icon from '@map/components/Icons';
/**
 * Turf é uma coleção de módulos com algoritmos geográficos.
 */
import * as turf from '@turf/turf';
/**
 * useFormik é um hook personalizado do React que retornará
 * todos os estados e auxiliares do Formik diretamente.
 */
import { useFormik } from 'formik';
/**
 * Importação da biblioteca leaflet a qual utiliza o OpenStreetMap,
 * é uma biblioteca de mapeamento leve e de codigo aberto, utiliza um banco
 * de dados geografico editável gratuito.
 */
import L from 'leaflet';
/**
 * useState é um hook que nos permite rastrear o estado em um
 * componente de função, o estado geralmente se refere a dados ou
 * propriedads que precisam ser rastreador em um aplicativo.
 * 
 * useEffect é um hook que permite executar efeitos colaterais em
 * seus componentes, por exemplo: buscar dados, atualizar diretamente
 * o DOM e cronômetros, ele aceita dois argumentos o segundo é opcional.
 * 
 * useCallback é um hook que retorna uma função de retorno
 * de chamada memorizada
 */
import { useState, useEffect, useCallback } from 'react';
import SliderColorPicker from 'views/MapView/components/SliderColorPicker';
/**
 *  useMap é um hook personalizado criado para gerenciar a comunicação
 *  dos componentes com o mapa.
 */
import { useMap } from 'views/MapView/hooks';
import * as Yup from 'yup';

/**
 * Ferramenta Intersect
 * Uma funcionalidade usada em camadas criadas e importadas do tipo polígono
 * Com ela é possivel criar um poligo a partir da área de sobreposição comum
 * entre as feições de uma ou duas camadas selecionadas no menu de camadas.
 * Também é posśivel especificar as feições selecionando-as na tabela de atributos.
 * 
 * @param {string} mapContext Context
 * @param {boolean} isActive Verificação
 * @param {boolean} setIsActive Seta o estado
 * @param {*} props Resto
 * @returns 
 */
export const Intersect = ({ mapContext, isActive, setIsActive, ...props }) => {  
  const [arrSelectedLayers, setArrSelectedLayers] = useState([]);
  const [saveModalOpen, setSaveModalOpen] = useState(false);  
  const [runingIntersect, setRuningIntersect] = useState(false);
  const [collectionIntersect, setCollectionIntersect] = useState({});

  const { layers, map, addLayer, setLoadingInMap} = useMap();

  const formik = useFormik({
    initialValues: {
      layerName: '',
      layerStyle: null,
    },
    validationSchema: Yup.object().shape({
      layerName: Yup.string().required('Campo obrigatório'),
    }),
    onSubmit: (values) => {
      saveAsLayer(values.layerName, values.layerStyle);
    },
  });

  const { resetForm } = formik;

  /**
   * Salva a operação de intersect realizada em uma nova camada, que será lista no menu
   * @param {*} layerName Nome que deverá aparecer no menu
   * @param {*} layerStyle Estilo de como a camada deverá ser representada no mapa   
   */
  const saveAsLayer = useCallback((layerName, layerStyle) => {
    if (collectionIntersect) {
      const customRender = L.canvas({ pane: 'mixedPane' });
      let options = {
        pane: 'mixedPane',
        renderer: customRender,
        style: layerStyle,
      };

      const geoJsonLayer = L.geoJSON(collectionIntersect, options);
      let layerToAdd = new Layer(
        null,
        'criada',
        null,
        layerName,
        null,
        null,
        null,
        null,
        null
      );      
      layerToAdd.setLeafletLayer(geoJsonLayer);
      layerToAdd.setLayerStyle(layerStyle);      
      let countIdFeature = 1;      
      layerToAdd.leafletLayer.eachLayer((feature) => {        
        let newFeatureProperties = {};
        newFeatureProperties.ID_GBA = countIdFeature;
        newFeatureProperties = {
          ...newFeatureProperties,
          ...feature.feature.properties,
        }        
        newFeatureProperties['Área (m²)'] = measureArea(feature.feature.geometry.coordinates, true);
        newFeatureProperties['Área (ha)'] = measureArea(feature.feature.geometry.coordinates, true) / 10000;
        feature.feature.properties = newFeatureProperties;
        
        countIdFeature++;
      });
      addLayer(layerToAdd);      
      setSaveModalOpen(false);
    }    
  }, [collectionIntersect, addLayer]);

  /**
   * Reseta formik para estado inicial e fecha modal
   */
  const handleCloseSaveModal = useCallback(() => {
    resetForm();
    setSaveModalOpen(false);
  }, [resetForm]);
  
  /**
   * Executa operação de intersect sobre as feições
   * mantendoas respectivas colunas das feições envolvidas
   * renomeando-as com _X no final do label
   */
  const intersectFeatures = useCallback((arrFeaturesToIntersect, arrSecondFeaturesToIntersect = []) => {
    let arrIntersectedFeatures = [];
    let sameLayer = arrSecondFeaturesToIntersect.length === 0 ? true : false;

    arrFeaturesToIntersect.forEach((f, i) => {
      if (sameLayer) {
        arrSecondFeaturesToIntersect = arrFeaturesToIntersect.slice(i + 1);
      }

      for (let iNextFeature = 0; iNextFeature <= arrSecondFeaturesToIntersect.length - 1; iNextFeature++) {
        arrIntersectedFeatures.push(
          turf.intersect(
            f, 
            arrSecondFeaturesToIntersect[iNextFeature], 
            {
              properties: {
                ...getPropertiesChangedOldFeature(f.properties),
                ...getPropertiesChangedOldFeature(arrSecondFeaturesToIntersect[iNextFeature].properties, "_2")
              }
            }
          )
        );
      }
    });
      
    return arrIntersectedFeatures;
  }, []);

  /**
   * Inicia procedimento para execução da interseção
   */
  const runIntersect = useCallback(() => {         
    if (!runingIntersect) {
      setRuningIntersect(true);
      setLoadingInMap(true);
      // Foi necessário executar a operação de de intersect dentro de um setTimeout, 
      // pois o mesmo trava a aplicação, impedindo a visualização do "loading".
      setTimeout(function () {
        let arrIntersectedFeatures = arrSelectedLayers.length === 1
          ? intersectFeatures(getFeaturesTurf(arrSelectedLayers[0]))
          : intersectFeatures(getFeaturesTurf(arrSelectedLayers[0]), getFeaturesTurf(arrSelectedLayers[1]));
        arrIntersectedFeatures = arrIntersectedFeatures.filter((f) => f);          
        if (arrIntersectedFeatures.length > 0) {          
          setCollectionIntersect(turf.featureCollection(arrIntersectedFeatures));
          setSaveModalOpen(true);          
        } else {
          geoAlert({
            message: `Não é possível gerar a camada, pois não há interseção entre as feições`,
          });
        }  
        setRuningIntersect(false);   
        setLoadingInMap(false);
      }, 500);
    }      
  }, [runingIntersect, arrSelectedLayers, intersectFeatures, setLoadingInMap]);  
  
  /** EFFECTS */

  /**
   * Habilita ferramenta de acordo com a camada selecionada, visibilidade e tipo
   */
  useEffect(() => {
    let selectedLayers = layers.filter((l) => l.isSelected && l.visible);            
    if (
      // selectedLayers.length === 1 &&
      // (['importada', 'criada'].includes(selectedLayers[0].type) ||
      //   selectedLayers[0].getService() === 'WFS')
      (selectedLayers.length === 1
         && ["importada", "criada"].includes(selectedLayers[0].type)
         && ["Polygon", "MultiPolygon"].includes(selectedLayers[0].dataType))
    ) {
      setArrSelectedLayers([selectedLayers[0]]);
    } else if ((selectedLayers.length === 2
      && ['importada', 'criada'].includes(selectedLayers[0].type)
      && ['importada', 'criada'].includes(selectedLayers[1].type)
      && ["Polygon", "MultiPolygon"].includes(selectedLayers[0].dataType)
      && ["Polygon", "MultiPolygon"].includes(selectedLayers[1].dataType))
      ) {
        setArrSelectedLayers([selectedLayers[0], selectedLayers[1]]);
    } else {
      setArrSelectedLayers([]);
    }
  }, [layers]);

  /**
   * Desabilita ferramenta caso não haja camada selecionada
   */
  useEffect(() => {    
    if (arrSelectedLayers.length === 0 && isActive) {
      setIsActive(false);
    }
  }, [arrSelectedLayers, isActive, setIsActive]);

  /**
   * Reseta ferramenta ao ser desabilitada
   */
  useEffect(() => {
    if (!isActive) {      
      handleCloseSaveModal();      
    }
  }, [isActive, handleCloseSaveModal]);

  /**
   * Adiciona e executa um evento customizado. Ao final remove evento.
   */
  useEffect(() => {
    if (isActive && !runingIntersect) {
      map.on('run-intersect', runIntersect);
      map.fire('run-intersect'); 
      setIsActive(false);      
      map.off('run-intersect');
    }
  }, [isActive, runingIntersect, map, runIntersect, setIsActive]);

  return (
    <Wrap>
      <ButtonTooltip
        tooltip={Intersect.properties.alias}
        description={Intersect.properties.description}
        onClick={() => {          
          setIsActive();          
        }}
        tooltipDisabled={isActive}
        active={isActive}
        disabled={arrSelectedLayers.length === 0}
      >        
        <Icon i="map-toolbar-intersect"></Icon>
      </ButtonTooltip>      

      <CustomModalSaveAsLayer
        title="Salvar Camada"
        saveModalOpen={saveModalOpen}
        handleCloseSaveModal={handleCloseSaveModal}
        formik={formik}
        SliderColorPicker={  <SliderColorPicker
          geometryType="Polygon"
          autoSelect={false}
          selectedSymbology={formik.values.layerStyle}
          onSelect={(style) => formik.setFieldValue('layerStyle', style)}
        />}
      />  
      
    </Wrap>
  );
};

Intersect.properties = {
  id: 'CPN-TB-A-INTERSECT',
  alias: 'Interseccionar',
  description: 'Realiza a interseção de feições que compartilham de uma área em comum. Selecionado uma ou duas camadas criada(s) e/ou importada(s) com feições do tipo polígono, podendo especificar feições.',
};

export default Intersect;
